import gql from 'graphql-tag';

export default gql`
  fragment sharedDomainFragment on SharedDomain {
    id
    domain
  }
`;
